<template>
    <div class="foot_box2" v-show="comshow">
        <div class="nav_box flex2">
            <div
                class="nav_item flex2"
                :class="curtAct2 == index ? 'act_sty42' : ''"
                v-for="(item, index) in footList2"
                :key="item.title"
                @click.stop="handleTabClick(index, item.path)"
            >
                <img :src="item.img" />
                <span>{{ item.title }}</span>
            </div>
        </div>
        <div class="heitiao flex2">
            <span></span>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            fw1: false,
            fw2: false,
            comshow: true,
        };
    },
    computed: {
        ...mapState(["footList2", "curtAct2"]),
    },
    watch: {
        $route(to, from) {
            if (this.$route.path == "/productDetail") {
                this.comshow = false;
            } else {
                this.comshow = true;
            }
        },
    },
    methods: {
        handleTabClick(index, path) {
            if (path) {
                if (path.indexOf("http") != -1) {
                    window.location.href = path;
                } else {
                    this.$router.push(path);
                }
            }
        },
    },
};
</script>
<style lang="scss">
.act_sty42 {
    span {
        color: red !important;
    }
}
.foot_box2 {
    overflow: hidden;
    padding-bottom: 0.3rem;
    background-color: #fff;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    box-shadow: 0 -5px 5px 0 rgba(0, 0, 0, 0.1);
    .nav_box {
        width: 100%;
        .nav_item {
            width: 20%;
            flex-wrap: wrap;
            align-content: center;
            position: relative;
            padding: 0.21rem 0;
            img {
                height: 25px;
                width: auto;
                margin-top: 2px;
            }
            span {
                color: gray;
                font-size: 10px;
                text-align: center;
                display: block;
                width: 100%;
                text-align: center;
                margin-top: 10px;
            }
        }
    }
    .heitiao {
        width: 100%;
        margin-top: 0.15rem;
        span {
            width: 50%;
            height: 6px;
            background-color: #000;
            border-radius: 10px;
            display: inline-block;
        }
    }
}
</style>